import { createFileRoute, Outlet } from '@tanstack/react-router';
import { operationsGuard } from '@/lib/route-guards';

export const Route = createFileRoute('/operations/organizations/__root')({
  beforeLoad: operationsGuard,
  component: () => <Outlet />,
});
